import { ShelfLifeEntry } from './shelfLifeTypes';

export const produceEntries: ShelfLifeEntry[] = [
  { keywords: ['apple', 'apples'], pantry: 7, fridge: 28 },
  { keywords: ['banana', 'bananas'], pantry: 5, fridge: 7 },
  { keywords: ['orange', 'oranges', 'clementine', 'mandarin', 'tangerine'], pantry: 7, fridge: 21 },
  { keywords: ['strawberry', 'strawberries'], fridge: 5, freezer: 180 },
  { keywords: ['blueberry', 'blueberries', 'raspberry', 'raspberries', 'blackberry'], fridge: 5, freezer: 180 },
  { keywords: ['grape', 'grapes'], fridge: 10 },
  { keywords: ['lemon', 'lemons', 'lime', 'limes'], fridge: 21 },
  { keywords: ['avocado'], pantry: 4, fridge: 5 },
  { keywords: ['peach', 'nectarine', 'plum'], pantry: 4, fridge: 5 },
  { keywords: ['watermelon', 'cantaloupe', 'honeydew', 'melon'], fridge: 5 },
  { keywords: ['pineapple'], fridge: 5 },
  { keywords: ['mango'], pantry: 5, fridge: 7 },
  { keywords: ['lettuce', 'romaine', 'mixed greens', 'salad mix', 'arugula'], fridge: 5 },
  { keywords: ['spinach', 'kale', 'collard greens', 'swiss chard'], fridge: 5, freezer: 300 },
  { keywords: ['tomato', 'tomatoes'], pantry: 5, fridge: 7 },
  { keywords: ['cucumber', 'cucumbers'], fridge: 7 },
  { keywords: ['bell pepper', 'pepper', 'peppers'], fridge: 7, freezer: 180 },
  { keywords: ['carrot', 'carrots'], fridge: 21, freezer: 300 },
  { keywords: ['celery'], fridge: 14 },
  { keywords: ['broccoli'], fridge: 5, freezer: 300 },
  { keywords: ['cauliflower'], fridge: 7, freezer: 300 },
  { keywords: ['corn', 'corn on the cob'], fridge: 3, freezer: 240 },
  { keywords: ['green beans', 'snap beans'], fridge: 5, freezer: 240 },
  { keywords: ['mushroom', 'mushrooms'], fridge: 7 },
  { keywords: ['zucchini', 'squash', 'yellow squash'], fridge: 7, freezer: 180 },
  { keywords: ['onion', 'onions', 'yellow onion', 'red onion', 'white onion'], pantry: 30, fridge: 14 },
  { keywords: ['garlic'], pantry: 60, fridge: 14 },
  { keywords: ['potato', 'potatoes', 'russet', 'yukon'], pantry: 21 },
  { keywords: ['sweet potato', 'sweet potatoes', 'yam'], pantry: 21 },
  { keywords: ['cabbage'], fridge: 14 },
  { keywords: ['asparagus'], fridge: 4 },
  { keywords: ['green onion', 'scallion', 'scallions'], fridge: 7 },
  { keywords: ['herb', 'cilantro', 'parsley', 'basil', 'dill', 'mint', 'rosemary', 'thyme'], fridge: 7 },
  { keywords: ['ginger', 'fresh ginger'], fridge: 21, freezer: 180 },
  { keywords: ['jalapeno', 'serrano', 'habanero', 'chili pepper'], fridge: 14 },
];
